import { Component, OnInit, AfterViewInit, TemplateRef, ViewChild, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { fadeInOut } from '../../../services/animations';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from "../../../services/app-translation.service";
import { Utilities } from "../../../services/utilities";
import { AccountService } from "../../../services/account.service";
import { Configuration, MethodVersionService, MethodVersionViewModel, ReportMetadataService, Int32StringTuple, MethodVersionOverviewViewModel } from '../../index';
import { Observable } from 'rxjs';
import { Permission } from '../../../models/permission.model';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-method-version-list',
    templateUrl: './method-version-list.component.html',
    styleUrls: ['./method-version-list.component.scss'],
    animations: [fadeInOut],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MethodVersionListComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;
    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    displayedColumns = ['name', 'businessCategoryName', 'enabled', 'preview', 'updatedDate', 'reportCount', 'actions'];
    dataSource: MatTableDataSource<MethodVersionOverviewViewModel>;
    loadingIndicator: boolean;
    currentSearchText: string;


    constructor(
        private alertService: AlertService,
        private translationService: AppTranslationService,
        private authService: AuthService,
        private methodVersionService: MethodVersionService,
        private metadataService: ReportMetadataService,
        private snackBar: MatSnackBar) {

        this.dataSource = new MatTableDataSource<MethodVersionOverviewViewModel>();
        this.currentSearchText = "";
    }

    ngOnInit() {
        this.loadData();
    }

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    public applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue;
    }

    private refresh() {
        // Causes the filter to refresh there by updating with recently added data.
        this.applyFilter(this.dataSource.filter);
    }

    public loadData() {
        this.alertService.startLoadingMessage();
        this.loadingIndicator = true;

        this.methodVersionService.getMethodVersions().subscribe(
            orgs => this.onDataLoadSuccessful(orgs),
            error => this.onDataLoadFailed(error)
        );
    }

    private onDataLoadSuccessful(f: MethodVersionOverviewViewModel[]) {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;
        this.dataSource.data = f;
    }

    private onDataLoadFailed(error: any) {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;

        this.alertService.showStickyMessage(this.translationService.getTranslation("Error"), this.translationService.getTranslation("FetchErrorMessage") + "\r\n" + Utilities.getHttpResponseMessage(error),
            MessageSeverity.error, error);
    }

    hasPermissionToChange(): boolean {
        return this.authService.userHasPermission(Permission.manageModel);
    }
}
